{
  "name": "gnvert-analyse",
  "version": "2.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o --proxy-config proxy.config.json --configuration=gnvert",
    "start:integration": "ng serve -o --configuration=integration",
    "start:prod": "ng serve -o --configuration=prod",
    "start:local": "ng serve -o --configuration=local",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/gnvert-analyse/stats.json",
    "linter": "ng lint --fix",
    "build": "ng build",
    "build:integration": "ng build --output-hashing=all --configuration=integration,gnvert",
    "build:prod": "ng build --output-hashing=all --configuration=prod,gnvert",
    "build:local": "ng build --configuration=gnvert,local",
    "build:gnvert": "ng build --configuration=gnvert",
    "swagger-gen": "ng-openapi-gen -c ng-swagger-gen-web-secured.json && ng-openapi-gen -c ng-swagger-gen-web-public.json && ng-openapi-gen -c ng-swagger-gen-gnvert-secured.json && ng-openapi-gen -c ng-swagger-gen-gnvert-public.json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e --configuration=integration",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "postbuild": "node postbuild.js"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^19.2.18",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/google-maps": "^19.2.18",
    "@angular/language-service": "^19.2.14",
    "@angular/material": "^19.2.18",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@cubejs-client/core": "^1.3.21",
    "@cubejs-client/ngx": "^1.3.21",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ngrx/component-store": "^19.2.1",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/router-store": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@okta/okta-angular": "^6.5.1",
    "@okta/okta-auth-js": "^7.12.1",
    "@okta/okta-signin-widget": "^7.32.1",
    "@primeng/themes": "^19.1.4",
    "@rx-angular/cdk": "^19.1.0",
    "@rx-angular/template": "^19.2.2",
    "chart.js": "^3.9.1",
    "core-js": "^3.43.0",
    "daisy-design-system-front": "file:design-system-package/daisy-design-system-front-2.0.0.tgz",
    "dayjs": "^1.11.13",
    "echarts": "^5.6.0",
    "file-saver": "^2.0.5",
    "immer": "^10.1.1",
    "jwt-decode": "^4.0.0",
    "leaflet": "^1.9.4",
    "lodash": "^4.17.21",
    "lodash-es": "^4.17.21",
    "moment": "^2.30.1",
    "ng-openapi-gen": "^0.53.0",
    "ng-swagger-gen": "^2.3.1",
    "ng2-charts": "^3.1.2",
    "ng2-date-picker": "^19.0.0",
    "ngx-device-detector": "^9.0.0",
    "ngx-echarts": "^16.2.0",
    "ngx-logger": "^5.0.12",
    "ngx-quill": "^27.1.2",
    "ngx-spinner": "^19.0.0",
    "popper.js": "^1.16.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.3",
    "primeng-sass-theme": "^17.9.0",
    "quill": "^2.0.3",
    "quill-mention": "^6.1.1",
    "rxjs": "~7.8.0",
    "simple-crypto-js": "^3.0.1",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.17",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.2"
  }
}
